document.addEventListener('DOMContentLoaded', () => {

// sliders
  const filmSwiper = new Swiper('#pcSwiper .c-film-swiper', {
    slidesPerView: 2,
    loop: true,
    navigation: {
      nextEl: '#pcSwiper .c-film-swiper-next',
      prevEl: '#pcSwiper .c-film-swiper-prev'
    }
  });
  const filmMobileSwiper = new Swiper('#mobileSwiper .c-film-swiper', {
    slidesPerView: 1,
    loop: true,
    navigation: {
      nextEl: '#mobileSwiper .c-film-swiper-next',
      prevEl: '#mobileSwiper .c-film-swiper-prev'
    }
  });
  const filmModalSwiper = new Swiper('.l-film-modal .c-modal-swiper', {
    slidesPerView: 1,
    loop: true,
    navigation: {
      nextEl: '.l-film-modal .c-film-swiper-next',
      prevEl: '.l-film-modal .c-film-swiper-prev'
    }
  });
  const galleryModal = new bootstrap.Modal(document.getElementById('filmModal'));
  document.querySelectorAll('#pcSwiper .swiper-slide').forEach((slide, index) => {
    slide.addEventListener('click', () => {
      console.log(slide, index);
      galleryModal.show();
      filmModalSwiper.slideTo(index, 0);
    });
  });
  document.querySelectorAll('#mobileSwiper .swiper-slide').forEach((slide, index) => {
    slide.addEventListener('click', () => {
      console.log(slide, index);
      galleryModal.show();
      filmModalSwiper.slideTo(index, 0);
    });
  });

// tab
  const storyTabs = document.querySelectorAll('.l-section--story [data-bs-toggle="tab"]');
  const storyImages = document.querySelectorAll('.l-section--story .c-header-wrapper');
  const bookmarkEl = document.querySelector('.l-section--story .l-bookmark');
  const activeTab = document.querySelector('.l-section--story .nav-link.active');
  storyTabs.forEach(tab => {
    tab.addEventListener('shown.bs.tab', e => {
      const targetImgId = e.target.dataset.img;
      storyImages.forEach(img => {
        img.id === targetImgId ? img.classList.add('show') : img.classList.remove('show');
      });
      const newClass = e.target.dataset.contentClass;
      bookmarkEl.classList.remove('l-orange-style', 'l-teal-style');
      if (newClass) {
        bookmarkEl.classList.add(newClass);
      }
    });
  });
  if (activeTab) {
    const targetImgId = activeTab.dataset.img;
    storyImages.forEach(img => {
      img.id === targetImgId ? img.classList.add('show') : img.classList.remove('show');
    });
  }
});
